import { Nav } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { Users, PawPrint, Layers, MapPin, Home, ClipboardList, FileText, LayoutDashboard, Calendar } from 'lucide-react'

export default function SidebarClient({ rol, logo = '/images/logotipo-rumiantec.jpg'}) {
	const { t } = useTranslation()
	const {pathname} = useLocation()

  	return (
		<div className="sidebar d-none d-sm-block" id="sidebar">
			<div className='text-center my-2'>
				<img id='logo' className='mx-auto' src={logo} alt='logo'/>
			</div>
			<Nav className="flex-column p-0">
				{(rol === 'admin') && (
					<>
						<Nav.Item className={pathname.includes(`${t("url.admin.admin")}/${t("url.admin.dashboard")}`) ? 'active' : ''}>
							<Link to={`/${t("url.admin.admin")}/${t("url.admin.dashboard")}`}><Home size={16} className="me-2" /> {t('menus.dashboard')}</Link>
						</Nav.Item>
						<hr className='separador'/>
						<Nav.Item className={pathname.includes(`${t("url.admin.admin")}/${t("url.admin.users")}`) ? 'active' : ''}>
							<Link to={`/${t("url.admin.admin")}/${t("url.admin.users")}`}><Users size={16} className="me-2" /> {t('menus.users')}</Link>
						</Nav.Item>
						<hr className='separador'/>
						<Nav.Item className={pathname.includes(`${t("url.admin.admin")}/${t("url.admin.animals")}`) ? 'active' : ''}>
							<Link to={`/${t("url.admin.admin")}/${t("url.admin.animals")}`}><PawPrint size={16} className="me-2" /> {t('menus.animals')}</Link>
						</Nav.Item>
						<Nav.Item className={pathname.includes(`${t("url.admin.admin")}/${t("url.admin.lots")}`) ? 'active' : ''}>
							<Link to={`/${t("url.admin.admin")}/${t("url.admin.lots")}`}><Layers size={16} className="me-2" /> {t('menus.lots')}</Link>
						</Nav.Item>
						<Nav.Item className={pathname.includes(`${t("url.admin.admin")}/${t("url.admin.zones")}`) ? 'active' : ''}>
							<Link to={`/${t("url.admin.admin")}/${t("url.admin.zones")}`}><MapPin size={16} className="me-2" /> {t('menus.zones')}</Link>
						</Nav.Item>
						<Nav.Item className={pathname.includes(`${t("url.admin.admin")}/${t("url.admin.farms")}`) ? 'active' : ''}>
							<Link to={`/${t("url.admin.admin")}/${t("url.admin.farms")}`}><Home size={16} className="me-2" /> {t('menus.farms')}</Link>
						</Nav.Item>
						<hr className='separador'/>
						<Nav.Item className={pathname.includes(`${t("url.admin.admin")}/${t("url.admin.templates")}`) ? 'active' : ''}>
							<Link to={`/${t("url.admin.admin")}/${t("url.admin.templates")}`}><FileText size={16} className="me-2" /> {t('menus.templates')}</Link>
						</Nav.Item>
						<Nav.Item className={pathname.includes(`${t("url.admin.admin")}/${t("url.admin.protocols")}`) ? 'active' : ''}>
							<Link to={`/${t("url.admin.admin")}/${t("url.admin.protocols")}`}><ClipboardList size={16} className="me-2" /> {t('menus.protocols')}</Link>
						</Nav.Item>
					</>
				)}
				{(rol === 'technical') && (
					<>
						<Nav.Item className={pathname.includes(`${t("url.technical.technical")}/${t("url.technical.dashboard")}`) ? 'active' : ''}>
							<Link to={`/${t("url.technical.technical")}/${t("url.technical.dashboard")}`}><LayoutDashboard size={16} className="me-2" /> {t('menus.dashboard')}</Link>
						</Nav.Item>
						<hr className='separador'/>
						<Nav.Item className={pathname.includes(`${t("url.technical.technical")}/${t("url.technical.calendar")}`) ? 'active' : ''}>
							<Link to={`/${t("url.technical.technical")}/${t("url.technical.calendar")}`}><Calendar size={16} className="me-2" /> {t('menus.calendar')}</Link>
						</Nav.Item>
						<Nav.Item className={pathname.includes(`${t("url.technical.technical")}/${t("url.technical.protocols")}`) ? 'active' : ''}>
							<Link to={`/${t("url.technical.technical")}/${t("url.technical.protocols")}`}><ClipboardList size={16} className="me-2" /> {t('menus.protocols')}</Link>
						</Nav.Item>
					</>
				)}
				{rol === 'breeder' && (
					<>
						<Nav.Item className={pathname.includes(`${t("url.breeder.breeder")}/${t("url.breeder.dashboard")}`) ? 'active' : ''}>
							<Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.dashboard")}`}>
								<LayoutDashboard size={16} className="me-2" /> {t('menus.dashboard')}
							</Link>
						</Nav.Item>

						<hr className='separador'/>

						<Nav.Item className={pathname.includes(`${t("url.breeder.breeder")}/${t("url.breeder.calendar")}`) ? 'active' : ''}>
							<Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.calendar")}`}>
								<Calendar size={16} className="me-2" /> {t('menus.calendar')}
							</Link>
						</Nav.Item>

						<hr className='separador'/>

						<Nav.Item className={pathname.includes(`/${t("url.breeder.event")}/${t("url.breeder.register")}`) ? 'active' : ''}>
							<details>
								<summary className='cursor'><i className="fas fa-cow me-2" /> {t('menus.events')}</summary>
								<ul className="submenu">
									<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/birth`}>{t('menus.event_birth')}</Link></li>
									<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/acquisition`}>{t('menus.event_acquisition')}</Link></li>
									<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/death`}>{t('menus.event_death')}</Link></li>
									<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/sacrifice`}>{t('menus.event_sacrifice')}</Link></li>
									<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/desvieje`}>{t('menus.event_desvieje')}</Link></li>
									<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/sale`}>{t('menus.event_sale')}</Link></li>
									<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/movement`}>{t('menus.event_movement')}</Link></li>
									<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/review`}>{t('menus.event_review')}</Link></li>
									<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/reviewMark`}>{t('menus.event_reviewMark')}</Link></li>
									<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/status`}>{t('menus.event_status')}</Link></li>
									<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/heat`}>{t('menus.event_heat')}</Link></li>
									<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/birthProcess`}>{t('menus.event_birthProcess')}</Link></li>
									<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/abort`}>{t('menus.event_abort')}</Link></li>
									<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/weaning`}>{t('menus.event_weaning')}</Link></li>
									<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/weight`}>{t('menus.event_weight')}</Link></li>
									<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/insemination`}>{t('menus.event_insemination')}</Link></li>
									<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/semental`}>{t('menus.event_semental')}</Link></li>
								</ul>
							</details>
						</Nav.Item>
					</>
				)}
			</Nav>
		</div>
	)
}